import { createSelector } from 'reselect';
const initialState = {
    code: '',
    expirationTime: '',
};
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["CARE_ORDER_BABY_UPDATE"] = "careOrderBaby/update";
})(ACTION_TYPES || (ACTION_TYPES = {}));
export default function careOrderBabyReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.CARE_ORDER_BABY_UPDATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
// actions
export const careOrderBabyUpdate = (payload) => ({
    type: ACTION_TYPES.CARE_ORDER_BABY_UPDATE,
    payload,
});
// selectors
export const selectCareOrderBaby = createSelector((state) => state.careOrderBaby, (careOrderBaby) => careOrderBaby);
